import React, { Component } from "react";

// Libs
import { Modal } from "react-bootstrap";
import { navigate, Link } from "gatsby";
import _ from "lodash";
import SimpleBar from "simplebar-react";
import { getCount } from "../../actions/memberAction";
import { numberFormat } from "../../actions/miscAction";
import { getPersonalInfo } from "../../actions/dashboardAction";

class NewDashboardSidebarMobile extends Component {
  state = { tab: 1, filtersShow: 6, defaultActiveKey: ["0"] };

  state = {
    showProfileNav: false,
    showBuyingNav: false,
    showFullNav: true,
    user: null,
    showSellingNav: false,
    showCompanyNav: false,
    dashboardCount: {},
    profileData: null,
  };

  componentDidMount = () => {
    if (localStorage.getItem("token")) {
      const user = JSON.parse(localStorage.getItem("member"));
      this.setState({ user });
      getCount((res) => {
        if (res.status === 200) {
          this.setState({
            dashboardCount: res.data,
          });
        }
      });
      getPersonalInfo()
        .then((res) => {
          this.setState({ profileData: res.data });
          if (
            this.props?.page === "category-preferences" ||
            this.props?.page === "region-preferences" ||
            this.props?.page === "dashboard"
          ) {
            this.props?.setPersonalData(res?.data);
          }
        })
        .catch((err) => {
          console.log("Error", err);
        });
    }
  };

  getMember = () => {
    if (typeof window !== "undefined" && localStorage.getItem("member")) {
      if (localStorage.getItem("mimicmember")) {
        return JSON.parse(localStorage.getItem("mimicmember"));
      } else {
        return JSON.parse(localStorage.getItem("member"));
      }
    }
  };

  render() {
    const member = typeof window !== "undefined" && JSON.parse(localStorage.getItem("member"));
    const mimicMember = typeof window !== "undefined" && JSON.parse(localStorage.getItem("mimicmember"));
    const dashboardCount = this.state.dashboardCount;
    const loggedInUser = this.getMember();

    return (
      <Modal
        className={"modal right-collapse fade modal_sm auto-height offcanvas-pannel-container"}
        show={this.props.showModal}
        onHide={this.props.toggleModal}
        id="dashboardProfileCollapsenew"
        tabindex="-1"
        role="dialog"
      >
        {" "}
        <SimpleBar autoHide={false} className="pannel-body" data-simplebar>
          <div class="admin-profile-box mob-dashboard-profile pt-0">
            <div class="admin-profile-block text-center position-relative">
              <div
                style={{ cursor: "pointer" }}
                class="btn-close ms-auto"
                data-bs-dismiss="modal"
                onClick={this.props.toggleModal}
              ></div>

              <h3>{this.state.user && this.state.user.name}</h3>
            </div>
            <div class="accordion">
              <div class={`accordion-item ${this.props.page === "dashboard" && "active"}`}>
                <div class="accordion-header">
                  <div
                    class="accordion-button arrow-hide collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                    onClick={(e) => {
                      e.preventDefault();
                      // this.props.setStep("dashboard");
                      navigate("/my-account/dashboard", { state: {} });
                      this.props.toggleModal(e);
                    }}
                  >
                    {/* <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.8">
                        <path
                          d="M12.1953 22C17.7182 22 22.1953 17.5228 22.1953 12C22.1953 6.47715 17.7182 2 12.1953 2C6.67246 2 2.19531 6.47715 2.19531 12C2.19531 17.5228 6.67246 22 12.1953 22Z"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.4351 7.76001L14.3151 14.12L7.95508 16.24L10.0751 9.88001L16.4351 7.76001Z"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg> */}
                    <span className="dashboard-mobile-menu-bold">Dashboard</span>
                  </div>
                </div>
              </div>

              <div
                class={`accordion-item dropdown ${
                  (this.props.page === "verification" ||
                    this.props.page === "payment-info" ||
                    this.props.page === "my-profile" ||
                    this.props.page === "change-password") &&
                  "active"
                }`}
              >
                <div
                  class={`accordion-header side-nav-accordion-header ${
                    this.state.showProfileNav && !this.state.showFullNav && "show"
                  }`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={(e) => {
                    this.setState({
                      showProfileNav: !this.state.showProfileNav,
                    });
                  }}
                >
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#myAccount"
                    aria-expanded="false"
                    aria-controls="myAccount"
                  >
                    {/* <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M20.2617 21V19C20.2617 17.9391 19.8403 16.9217 19.0901 16.1716C18.34 15.4214 17.3226 15 16.2617 15H8.26172C7.20085 15 6.18344 15.4214 5.43329 16.1716C4.68315 16.9217 4.26172 17.9391 4.26172 19V21"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.2617 11C14.4709 11 16.2617 9.20914 16.2617 7C16.2617 4.79086 14.4709 3 12.2617 3C10.0526 3 8.26172 4.79086 8.26172 7C8.26172 9.20914 10.0526 11 12.2617 11Z"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg> */}
                    <span className="dashboard-mobile-menu-bold">My Account</span>
                  </div>
                </div>
                <div
                  id="myAccount"
                  class={`${!this.state.showFullNav && "dropdown-menu"} menu-dropdown accordion-collapse collapse ${
                    this.state.showProfileNav && "show"
                  }`}
                >
                  <div class="accordion-body dashboard-mobile-spacing">
                    <ul>
                      <li>
                        <a
                          to="javascript:void(0)"
                          class={this.props.page == "my-profile" && "active"}
                          state={{}}
                          onClick={(e) => {
                            e.preventDefault();
                            // this.props.setStep("my-profile");
                            navigate("/my-account/my-profile", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          My Profile
                        </a>
                      </li>
                      <li>
                        <a
                          to="javascript:void(0)"
                          class={this.props.page == "verification" && "active"}
                          state={{}}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/verification", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Verification
                        </a>
                      </li>
                      <li>
                        <a
                          to="javascript:void(0)"
                          class={this.props.page == "payment-info" && "active"}
                          state={{}}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/payment-info", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Payment Info
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "category-preferences" && "active"}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/category-preferences", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          Category Preferences
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "region-preferences" && "active"}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/region-preferences", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          Region Preferences
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "manufacturer-preferences" && "active"}
                          onClick={(e) => {
                            e.preventDefault();

                            navigate("/my-account/manufacturer-preferences", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          Manufacturer Preferences
                        </a>
                      </li>
                      <li>
                        <a
                          to="javascript:void(0)"
                          class={this.props.page === "my-profile" && "active"}
                          state={{}}
                          onClick={(e) => {
                            e.preventDefault();
                            // this.props.setStep("my-profile");
                            navigate("/my-account/change-password", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          Change Password
                        </a>
                      </li>
                      <li>
                        <a
                          class={this.props.page === "ncnda" && "active"}
                          to="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/ncnda-list", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          NCNDA
                        </a>
                      </li>
                      {this.state.profileData?.unsubscribe ? (
                        <li>
                          <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/members/resubscribe", {
                                state: {},
                              });
                            }}
                          >
                            <span
                              className={`main-dashboard-sidebar-child-button ${
                                this.props.page === "ncnda" && "active main-dashboard-sidebar-child-selected-button"
                              }`}
                            >
                              Subscribe
                            </span>
                          </a>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                </div>
              </div>

              {((member && member.cid >= 1) || (mimicMember && mimicMember.cid >= 1)) && (
                <div class={`accordion-item dropdown ${this.props.page === "dashboard22" && "active"}`}>
                  <div
                    class="accordion-header"
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        showBuyingNav: false,
                        showProfileNav: false,
                        showSellingNav: false,
                        showCompanyNav: !this.state.showCompanyNav,
                      });
                    }}
                  >
                    <div
                      class="accordion-button collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#myCompany"
                      aria-expanded="false"
                      aria-controls="myCompany"
                    >
                      {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5 21V3H19V21M5 21H3M5 21H10M19 21H21M19 21H14M10 21V15H14V21M10 21H14M9 11H10M14 11H15M9 7H10M14 7H15"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg> */}
                      <span className="dashboard-mobile-menu-bold">Company</span>
                    </div>
                  </div>
                  <div
                    id="myCompany"
                    class={`${!this.state.showFullNav && "dropdown-menu"} menu-dropdown accordion-collapse collapse ${
                      this.state.showCompanyNav && "show"
                    }`}
                  >
                    <div class="accordion-body dashboard-mobile-spacing ">
                      <ul>
                        <li>
                          <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/my-account/business-units", {
                                state: {},
                              });
                              this.props.toggleModal(e);
                            }}
                          >
                            Business Units (
                            {dashboardCount && dashboardCount.businessUnits && dashboardCount.businessUnits.length > 0
                              ? dashboardCount.businessUnits.length
                              : "0"}
                            )
                          </a>
                        </li>
                        {/* <li>
                          <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/my-account/directory", { state: {} });
                              this.props.toggleModal(e);
                            }}
                          >
                            Directory
                          </a>
                        </li> */}
                        {/* <li>
                          <a
                            href="javascript:void(0)"
                            onClick={(e) => {
                              e.preventDefault();
                              this.props.setStep("directory");
                              this.props.toggleModal(e);
                            }}
                          >
                            Directory
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              )}
              <div class={`accordion-item dropdown ${this.props.page === "dashboar2d" && "active"}`}>
                <div
                  class={`accordion-header side-nav-accordion-header ${
                    this.state.showSellingNav && !this.state.showFullNav && "show"
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      showSellingNav: !this.state.showSellingNav,
                    });
                  }}
                >
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#selling"
                    aria-expanded="false"
                    aria-controls="selling"
                  >
                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.8">
                        <path d="M12 1V23" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg> */}
                    <span className="dashboard-mobile-menu-bold">Selling</span>
                  </div>
                </div>
                <div
                  id="selling"
                  class={`${!this.state.showFullNav && "dropdown-menu"} menu-dropdown accordion-collapse collapse ${
                    this.state.showSellingNav && "show"
                  }`}
                >
                  <div class="accordion-body dashboard-mobile-spacing">
                    <ul>
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/pending-and-redeployment", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          Pending (
                          {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.pending
                            ? dashboardCount.myBu.pending
                            : "0"}
                          )
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/active-listings", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          Active (
                          {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.active
                            ? dashboardCount.myBu.active
                            : "0"}
                          )
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/invoiced", {
                              state: {},
                            });
                            this.props.toggleModal(e);
                          }}
                        >
                          Invoiced (
                          {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.invoiced
                            ? dashboardCount.myBu.invoiced
                            : "0"}
                          )
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();

                            navigate("/my-account/archive", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Archived(
                          {dashboardCount && dashboardCount.myBu && dashboardCount.myBu.archive
                            ? dashboardCount.myBu.archive
                            : "0"}
                          )
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/my-account/my-sold-listings", {
                              state: {},
                            });
                          }}
                        >
                          {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.success
                            ? dashboardCount.successRate.success
                            : "0"}
                          /
                          {dashboardCount && dashboardCount.successRate && dashboardCount.successRate.total
                            ? dashboardCount.successRate.total
                            : "0"}
                          &nbsp; sold&nbsp;
                          {dashboardCount &&
                          dashboardCount.successRate &&
                          dashboardCount.successRate.success &&
                          dashboardCount.successRate.total
                            ? (
                                parseFloat(dashboardCount.successRate.success / dashboardCount.successRate.total) * 100
                              ).toFixed(2) + "%"
                            : "0%"}
                          &nbsp; success&nbsp;
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "current-bids" && "active"}
                          onClick={(e) => {
                            e.preventDefault();

                            navigate("/my-account/my-buyers", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          My Buyers ({dashboardCount && dashboardCount.buyerCount ? dashboardCount.buyerCount : 0})
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "listing-agreement" && "active"}
                          onClick={(e) => {
                            e.preventDefault();

                            navigate("/my-account/seller-listing-agreements", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Listing Agreements (
                          {dashboardCount && dashboardCount.listingAgreement ? dashboardCount.listingAgreement : 0})
                        </a>
                      </li>
                      <li>
                        <a href="/my-account/seller-asset-recovery-report" target="_blank">
                          Asset Recovery Report
                        </a>
                      </li>
                      <li>
                        <a href="/members/post-listing">Create New Listing</a>
                      </li>
                      {/* <li>
                        <a href="javascript:void(0)">My Buyers</a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div
                class={`accordion-item dropdown ${
                  (this.props.page === "current-bids" ||
                    this.props.page === "rfq" ||
                    this.props.page === "procurement-requests" ||
                    this.props.page === "watch-list" ||
                    this.props.page === "category-preferences" ||
                    this.props.page === "manufacturer-preferences" ||
                    this.props.page === "region-preferences") &&
                  "active"
                }`}
              >
                <div
                  class={`accordion-header side-nav-accordion-header ${
                    this.state.showBuyingNav && !this.state.showFullNav && "show"
                  }`}
                  onClick={(e) =>
                    this.setState({
                      showBuyingNav: !this.state.showBuyingNav,
                      // showProfileNav: false,
                    })
                  }
                >
                  <div
                    class="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#buying"
                    aria-expanded="false"
                    aria-controls="buying"
                  >
                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.4">
                        <path
                          d="M9 21C9.55228 21 10 20.5523 10 20C10 19.4477 9.55228 19 9 19C8.44772 19 8 19.4477 8 20C8 20.5523 8.44772 21 9 21Z"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M20 21C20.5523 21 21 20.5523 21 20C21 19.4477 20.5523 19 20 19C19.4477 19 19 19.4477 19 20C19 20.5523 19.4477 21 20 21Z"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M1 3H5L7.68 14.6044C7.77144 15.0034 8.02191 15.3618 8.38755 15.6169C8.75318 15.872 9.2107 16.0075 9.68 15.9997H19.4C19.8693 16.0075 20.3268 15.872 20.6925 15.6169C21.0581 15.3618 21.3086 15.0034 21.4 14.6044L23 7.33323"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path d="M14.5 3V11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18 9L14.5 12L11 9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </g>
                    </svg> */}
                    <span className="dashboard-mobile-menu-bold">Buying</span>
                  </div>
                </div>
                <div
                  id="buying"
                  class={`${!this.state.showFullNav && "dropdown-menu"} menu-dropdown accordion-collapse collapse ${
                    this.state.showBuyingNav && "show"
                  }`}
                >
                  <div class="accordion-body dashboard-mobile-spacing ">
                    <ul>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "current-bids" && "active"}
                          onClick={(e) => {
                            e.preventDefault();

                            navigate("/my-account/current-bids", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Current Bids ({dashboardCount && dashboardCount.myBids ? dashboardCount.myBids : 0})
                        </a>
                      </li>

                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "invoices" && "active"}
                          onClick={(e) => {
                            e.preventDefault();

                            navigate("/my-account/invoices", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Invoices
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "watch-list" && "active"}
                          onClick={(e) => {
                            e.preventDefault();
                            // this.props.setStep("watch-list");
                            navigate("/my-account/cart", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Cart ({dashboardCount && dashboardCount.totalBuCount ? dashboardCount.totalBuCount : 0})
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "my-questions" && "active"}
                          onClick={(e) => {
                            e.preventDefault();
                            // this.props.setStep("watch-list");
                            navigate("/my-account/my-questions", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          My Questions (
                          {dashboardCount && dashboardCount.totalQuestion ? dashboardCount.totalQuestion : 0})
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "rfq" && "active"}
                          onClick={(e) => {
                            e.preventDefault();
                            // this.props.setStep("watch-list");
                            navigate("/my-account/rfq", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          RFQ ({dashboardCount && dashboardCount.rfqRequest ? dashboardCount.rfqRequest : 0})
                        </a>
                      </li>
                      <li>
                        <a
                          href="javascript:void(0)"
                          class={this.props.page === "procurement-requests" && "active"}
                          onClick={(e) => {
                            e.preventDefault();
                            // this.props.setStep("watch-list");
                            navigate("/my-account/procurement-requests", { state: {} });
                            this.props.toggleModal(e);
                          }}
                        >
                          Procurement Requests (
                          {dashboardCount && dashboardCount.procurementRequest ? dashboardCount.procurementRequest : 0})
                        </a>
                      </li>

                      {/* <li>
                        <a href="javascript:void(0)">Invoices</a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              {typeof window !== "undefined" &&
                localStorage.getItem("member") &&
                JSON.parse(localStorage.getItem("member")).sec_list == 100103 &&
                !localStorage.getItem("mimictoken") && (
                  <div class={`accordion-item ${this.props.page === "dashboard" && "active"}`}>
                    <div class="accordion-header">
                      <div
                        class="accordion-button arrow-hide collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                        onClick={(e) => {
                          e.preventDefault();

                          navigate("/my-account/mimic-user", { state: {} });
                        }}
                      >
                        <span className="dashboard-mobile-menu-bold">Mimic User</span>
                      </div>
                    </div>
                  </div>
                )}
              <div class={`accordion-item `}>
                <div class="accordion-header">
                  <div
                    class="accordion-button arrow-hide collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    <span
                      className=" new-sidebar-accordion-button dashboard-mobile-menu-bold"
                      onClick={() => navigate("/my-account/listing-referrals")}
                    >
                      {" "}
                      Listing Referrals (
                      {dashboardCount && dashboardCount.buyerActivityCount ? dashboardCount.buyerActivityCount : 0})
                    </span>
                  </div>
                </div>
              </div>

              {/* {(mimicMember
                ? mimicMember.pipe_category && mimicMember.pipe_category.length > 0
                : member && member.pipe_category && member.pipe_category.length > 0) && 
                <div class={`accordion-item ${this.props.page === "dashboard" && "active"}`}>
                  <div class="accordion-header">
                    <div
                      class="accordion-button arrow-hide collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="false"
                      aria-controls="flush-collapseOne"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/my-account/global-pipe-trading", {
                          state: {},
                        });
                        
                      }}
                    >
                      
                      <span className="dashboard-mobile-menu-bold">Global Pipe Trading Screen</span>
                    </div>
                  </div>
                </div>
              )} */}
              <div class={`accordion-item `}>
                <div class="accordion-header">
                  <div
                    class="accordion-button arrow-hide collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne"
                    aria-expanded="false"
                    aria-controls="flush-collapseOne"
                  >
                    {/* <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.8">
                        <path
                          d="M12.1953 22C17.7182 22 22.1953 17.5228 22.1953 12C22.1953 6.47715 17.7182 2 12.1953 2C6.67246 2 2.19531 6.47715 2.19531 12C2.19531 17.5228 6.67246 22 12.1953 22Z"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16.4351 7.76001L14.3151 14.12L7.95508 16.24L10.0751 9.88001L16.4351 7.76001Z"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </svg> */}
                    <span className=" new-sidebar-accordion-button dashboard-mobile-menu-bold">
                      {" "}
                      Credit :&nbsp;
                      <span
                        className="credit-dashboard-new"
                        style={{
                          color: "#398a17",
                          textDecoration: "underline",
                        }}
                      >
                        {!_.isEmpty(dashboardCount)
                          ? dashboardCount && dashboardCount.credit
                            ? "$" + numberFormat(dashboardCount.credit)
                            : "$0.00"
                          : "$0.00"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <div class="accordion-header border-2">
                  <div
                    class="accordion-button arrow-hide collapsed"
                    onClick={(es) => {
                      es.preventDefault();
                      if (typeof window !== "undefined") {
                        window.localStorage.removeItem("token");
                        window.localStorage.removeItem("member");
                        window.localStorage.removeItem("buyerInspectionClosed");
                        window.localStorage.removeItem("buyerInspectionDate");
                        window.localStorage.removeItem("mimictoken");
                        window.localStorage.removeItem("mimicmember");
                        window.location.href = "/";
                      }
                    }}
                  >
                    {/* <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g opacity="0.8">
                        <path
                          d="M9.84766 21H5.84766C5.31722 21 4.80852 20.7893 4.43344 20.4142C4.05837 20.0391 3.84766 19.5304 3.84766 19V5C3.84766 4.46957 4.05837 3.96086 4.43344 3.58579C4.80852 3.21071 5.31722 3 5.84766 3H9.84766"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M16.8477 17L21.8477 12L16.8477 7"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                        <path
                          d="M21.8477 12H9.84766"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        ></path>
                      </g>
                    </svg> */}
                    <span className="dashboard-mobile-menu-bold">Logout</span>
                  </div>
                </div>
                <div id="buying" class="accordion-collapse collapse">
                  <div class="accordion-body dashboard-mobile-spacing"></div>
                </div>
              </div>
            </div>
          </div>
        </SimpleBar>
      </Modal>
    );
  }
}

export default NewDashboardSidebarMobile;
